import {
    faBell,
    faBookBookmark,
    faComments,
    faConciergeBell,
    faFile,
    faHandshake,
    faList,
    faMagnifyingGlassChart,
    faSchool,
    faUserPlus,
    faUsers,
    IconDefinition
} from "@fortawesome/free-solid-svg-icons";

export const CATEGORY_ICONS: { [id: string]: IconDefinition } = {
  'partner-success': faHandshake,
  'school-admin': faSchool,
  'school-district-reports': faList,
  'enroll': faUserPlus,
  'class-reports': faMagnifyingGlassChart,
  'small-group': faUsers,
  'student-engagement': faComments,
  'resources': faBookBookmark,
  'files': faFile,
  'support': faConciergeBell,
  'notifications': faBell,
  'getting-started': faList,
}
